/**
 * The top of a page: a crumb back up, the title with its count and anything that follows it (a chip, a live badge),
 * a line on what the page is for, and the page's actions. The Screen shell draws it; a page passes the words.
 */
import type { ReactNode } from 'react'
import { Link } from '../nav'
import s from './PageHeader.module.css'

export interface Crumb {
  label: string
  to: string
}

export function PageHeader({ title, count, after, description, crumb, actions }: { title: string; count?: number; after?: ReactNode; description?: ReactNode; crumb?: Crumb; actions?: ReactNode }) {
  return (
    <header className={s.head}>
      <div className={s.main}>
        {crumb && (
          <Link to={crumb.to} aria-label={`Back to ${crumb.label}`}>
            <span className={s.crumb}>{crumb.label}</span>
          </Link>
        )}
        <h1 className={s.title}>
          {title}
          {count !== undefined && <span className={s.n}>{count}</span>}
          {after}
        </h1>
        {description && <p className={s.desc}>{description}</p>}
      </div>
      {actions && <div className={s.acts}>{actions}</div>}
    </header>
  )
}
